module.exports = __webpack_public_path__ + "img/zh.9499dc42.svg";